import { pathOr } from 'ramda'
import { DepositBeneficiary } from 'types/finance'
import { $TSFixMe } from 'types/ts-migrate'

export type TPartialBankDetails = { accountNumber: string; [key: string]: any }

export const getLastFour = (bankDetails: TPartialBankDetails) => {
  const accountNumber: $TSFixMe = pathOr('', ['accountNumber'], bankDetails)
  return accountNumber.substring(accountNumber.length - 4, accountNumber.length)
}

export const transformDepositBeneficiaryForTransferChange = (
  beneficiary: DepositBeneficiary,
  transfer: boolean,
  agencyId: string,
  partyName: string,
  invoiceTypeName: string,
  ownerPartyId?: string,
): DepositBeneficiary => {
  // Guard: toggling to owner-managed (transfer === false) requires a resolved owner.
  // If the owner partyId hasn't loaded yet, do NOT silently re-route the deposit to the
  // agency/managed account — return the beneficiary unchanged so the toggle is a no-op
  // and the caller (and UI) keep the previous, correct routing.
  if (!transfer && typeof ownerPartyId === 'undefined') {
    return beneficiary
  }

  const isNoTransferWithOwner = !transfer && typeof ownerPartyId !== 'undefined'

  // default to transfer to reOS
  let beneficiaryTag = 'TenantDepositAccount'
  let partyId = agencyId
  let reference = `${partyName} ${invoiceTypeName}`

  // override if no transfer and owner account is passed
  if (isNoTransferWithOwner) {
    beneficiaryTag = 'Owner'
    partyId = ownerPartyId
  }

  return {
    ...beneficiary,
    beneficiary: {
      ...beneficiary.beneficiary,
      value: {
        ...beneficiary.beneficiary.value,
        transfer,
        beneficiaryTag,
        partyId,
        reference,
      },
    },
  }
}

export const transformDepositBeneficiaryForManagedByChange = (
  beneficiary: DepositBeneficiary,
  option: string,
  agencyId: string,
  partyName: string,
  invoiceTypeName: string,
  ownerPartyId?: string,
): DepositBeneficiary => {
  const isManagedByOwner = option.toLowerCase() === 'owner' && typeof ownerPartyId !== 'undefined'

  const reference = `${partyName} ${invoiceTypeName}`

  // prettier-ignore
  return {
    ...beneficiary,
    beneficiary: {
      ...beneficiary.beneficiary,
      value: {
        ...beneficiary.beneficiary.value,
        beneficiaryTag: isManagedByOwner ? 'Owner' : 'TenantDepositAccount', // Setting to 'Agency' transfers to the commission wallet.
        partyId: isManagedByOwner ? ownerPartyId : agencyId,
        reference,
      },
    },
  }
}
